import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
    Box,
    Typography,
    TextField,
    Button,
    List,
    ListItem,
    IconButton,
    FormHelperText,
    Paper
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { convertGenderText } from '../utils/consts';

const SupportingThoughtsSection = ({ onNext, formData }) => {
    const [newThought, setNewThought] = useState('');
    const { control, handleSubmit, formState: { errors }, setValue, watch } = useForm({
        defaultValues: {
            wspierajace_mysli_lista: [],
            wspierajace_mysli_dodatkowe_mysli: ''
        }
    });

    const thoughts = watch('wspierajace_mysli_lista');

    const handleAddThought = () => {
        if (newThought.trim() && thoughts.length < 3) {
            setValue('wspierajace_mysli_lista', [...thoughts, newThought.trim()]);
            setNewThought('');
        }
    };

    const handleRemoveThought = (index) => {
        setValue('wspierajace_mysli_lista', thoughts.filter((_, i) => i !== index));
    };

    // const validateThoughts = (value) => {
    //     if (!value || value.length < 3) {
    //         return "Proszę wymienić minimum 3 wspierające myśli";
    //     }
    //     return true;
    // };

    return (
        <Box component="form" onSubmit={handleSubmit(onNext)} sx={{ mt: 3 }}>
            <Typography variant="body1" color="blue" sx={{ mb: 3 }}>
                <b>Co to są wspierające myśli?</b>
                <br />
                Wspierające myśli to myśli, które pomagają radzić sobie z trudnościami,
                widzieć możliwości i wierzyć w siebie. Są one przeciwieństwem myśli
                niewspierających, które przytłaczają i ograniczają.
                <br />
                <b>Jakie mogą być wspierające myśli?</b>
                <br />
                To takie myśli, które dodają energii, motywują i sprawiają, że czujesz się lepiej. Zamiast myśleć: "Nie dam rady", możesz powiedzieć sobie: "Spróbuję, a jeśli się nie uda, to znajdę inny sposób".
                <br />
                <b>Dlaczego wspierające myśli są ważne?</b>
                <br />
                <ul>
                    <li><b>Wpływają na emocje:</b> Jeśli myślimy pozytywnie, czujemy się szczęśliwsi i bardziej spokojni.</li>
                    <li><b>Motywują do działania:</b> Wspierające myśli pomagają pokonywać trudności i osiągać cele.</li>
                    <li><b>Budują pewność siebie:</b> Kiedy wierzymy w siebie, łatwiej jest radzić sobie z wyzwaniami.</li>
                </ul>

            </Typography>

            <Typography variant="h6" color="black" gutterBottom>
                {`Kiedy ostatnio ${convertGenderText('mierzyłeś/aś', formData.zwrot_plec)} się z ważnym dla siebie wyzwaniem z którym sobie
                ${convertGenderText('poradziłeś/aś', formData.zwrot_plec)}, co takiego ${convertGenderText('myślałeś/aś', formData.zwrot_plec)} o sobie co było dla Ciebie wsparciem?
                Wymień 3 myśli, które Cię wtedy wspierały w pewności że sobie poradzisz:`}
            </Typography>

            <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                    <TextField
                        fullWidth
                        value={newThought}
                        onChange={(e) => setNewThought(e.target.value)}
                        placeholder="Wpisz wspierającą myśl..."
                        disabled={thoughts.length >= 3}
                    />
                    <Button
                        onClick={handleAddThought}
                        disabled={!newThought.trim() || thoughts.length >= 3}
                        color="primary"
                    >
                        Dodaj odpowiedź
                    </Button>
                </Box>

                <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                    <List>
                        {thoughts.map((thought, index) => (
                            <ListItem
                                key={index}
                                secondaryAction={
                                    <IconButton
                                        edge="end"
                                        aria-label="delete"
                                        onClick={() => handleRemoveThought(index)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                }
                            >
                                {`${index + 1}. ${thought}`}
                            </ListItem>
                        ))}
                    </List>
                </Paper>

                {errors.wspierajace_mysli_lista && (
                    <FormHelperText error>
                        {errors.wspierajace_mysli_lista.message}
                    </FormHelperText>
                )}

                {(thoughts.length < 3 && thoughts.length > 0) && (
                    <Typography variant="body2" color="primary">
                        Co jeszcze?
                    </Typography>
                )}
            </Box>
            {/* 
            <Controller
                name="wspierajace_mysli_dodatkowe_mysli"
                control={control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        fullWidth
                        multiline
                        rows={4}
                        label="Dodatkowe przemyślenia dotyczące Twoich wspierających myśli (opcjonalne)"
                        sx={{ mb: 3 }}
                    />
                )}
            /> */}

            <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={thoughts.length < 3}
            >
                Dalej
            </Button>
        </Box>
    );
};

export default SupportingThoughtsSection; 